import {Box} from "@mui/material";
import React from "react";

export const PaymentItem = ({children, onClick, error}) => {
    return <Box
        sx={{
            borderRadius: "5px",
            border: error ? "1.5px solid #d32f2f" : "1px solid #e0e0e0",
            width: "calc(100% - 20px)",
            margin: "10px 10px 0 10px",
            padding: "10px 20px",
            boxSizing: "border-box",
            bgcolor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
        }}
        onClick={onClick}
    >
        {children}
    </Box>
}

